import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './logo.webp';
import './styles/headers.css';

function Header() {
    const [showNav, setShowNav] = useState(false);

    const toggleNav = () => {
        setShowNav(prev => !prev);
    };

    const handleNavClick = () => {
        if (showNav) {
            setShowNav(false);
        }
    };

    return (
        <div className="container">
            <header className="d-flex flex-wrap justify-content-between py-3 mb-4 border-bottom position-relative">
                <Link to="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none">
                    <img src={logo} alt="Unique Gaming Hub Logo" width="40" height="40" className="me-2" />
                    <span className="fs-4">Omni Trade Beacon</span>
                </Link>

                <button className="d-md-none btn btn-light" onClick={toggleNav}>
                    <i className="fas fa-bars"></i> {/* Hamburger icon */}
                </button>

                <ul className={`nav nav-pills ${showNav ? 'show-on-mobile' : ''}`}>
                    <li className="nav-item">
                        <Link to="/" className="nav-link" aria-current="page" onClick={handleNavClick}>Home</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/trading-types" className="nav-link" onClick={handleNavClick}>Trading Types</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/faqs" className="nav-link" onClick={handleNavClick}>FAQs</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/about" className="nav-link" onClick={handleNavClick}>About</Link>
                    </li>
                </ul>
            </header>
        </div>
    );
}

export default Header;
